import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import AfterHours from './Components/AfterHours';
import { Routes, Route, BrowserRouter } from 'react-router-dom';

ReactDOM.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/menu" element={<App />} />
      <Route path="/after-hours" element={<AfterHours />} />
      <Route path="*" element={<App />} />
    </Routes>
  </BrowserRouter>,
  document.getElementById('root')
);

